module.exports = __webpack_public_path__ + "img/logo.5ab9af49.png";